/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvFromJSON, FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvToJSON, } from './FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnv';
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementGtagForDomainOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementGtagForDomainOptions(value) {
    if (!('Tag' in value) || value['Tag'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagForDomainOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Tag': json['Tag'],
        'Env': json['Env'] == null ? undefined : FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvFromJSON(json['Env']),
    };
}
export function FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagForDomainOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Tag': value['Tag'],
        'Env': FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvToJSON(value['Env']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementGtagForDomainOptions.js.map